//generate metrics data based on submitted worksheets

export const getMetricsData = (property, scenario, isFlip) => {
  if (!property || !scenario) {
    return {};
  }

  const { flipWorksheetSubmitted, purchaseWorksheetSubmitted } = property || {};
  const { rehabWorksheetSubmitted, refinancingWorksheetSubmitted } =
    scenario || {};

  // if it's not submitted, return empty object so we keep the headers but no data
  const {
    totalCashInvestedOnPurchase,
    totalProfitFlip,
    monthlyPreTaxCashFlow,
  } = isFlip
    ? flipWorksheetSubmitted
      ? property
      : {}
    : purchaseWorksheetSubmitted
    ? property
    : {};

  const { monthlyPreTaxCashFlowBuyAndHold, totalCashInvestedBuyAndHold } =
    rehabWorksheetSubmitted ? scenario : {};

  const { cashOut, newMonthlyPreTaxCashFlow } = refinancingWorksheetSubmitted
    ? scenario
    : {};

  const data = {};
  if (isFlip) {
    data.flipMetrics = [
      {
        title: 'Cash Needed',
        value: totalCashInvestedOnPurchase,
        unit: '$',
      },
      {
        title: 'Total Profit',
        value: totalProfitFlip,
        unit: '$',
      },
    ];
  } else {
    data.purchaseMetrics = [
      {
        title: 'Cash Needed',
        value: totalCashInvestedOnPurchase,
        unit: '$',
      },
      {
        title: 'Monthly Cash Flow',
        value: monthlyPreTaxCashFlow,
        unit: '$',
      },
    ];

    data.rehabMetrics = [
      {
        title: 'Cash Needed',
        value: totalCashInvestedBuyAndHold,
        unit: '$',
      },
      {
        title: 'Monthly Cash Flow',
        value: monthlyPreTaxCashFlowBuyAndHold,
        unit: '$',
      },
    ];

    data.refinancingMetrics = [
      {
        title: ['Cash In', 'Cash Out'],
        value: cashOut,
        unit: '$',
      },
      {
        title: 'Monthly Cash Flow',
        value: newMonthlyPreTaxCashFlow,
        unit: '$',
      },
    ];
  }

  return data;
};

//generate header message based on submitted worksheets
export const getHeaderMessage = (property, scenario, isFlip) => {
  const { flipWorksheetSubmitted, purchaseWorksheetSubmitted } = property || {};
  const { rehabWorksheetSubmitted, refinancingWorksheetSubmitted } =
    scenario || {};
  const numberSubmitted = isFlip
    ? flipWorksheetSubmitted
      ? 1
      : 0
    : [
        purchaseWorksheetSubmitted,
        rehabWorksheetSubmitted,
        refinancingWorksheetSubmitted,
      ].filter(Boolean).length;

  const unfinishedTitle = isFlip
    ? '/1 Analyses Complete'
    : '/3 Analyses Complete';
  const unfinishedDescription = isFlip
    ? 'Complete the Flip Worksheet to View Your Property Analysis'
    : 'Complete each worksheet to view the associated property analysis';

  switch (numberSubmitted) {
    case 0:
      return {
        title: `0${unfinishedTitle}`,
        description: unfinishedDescription,
      };
    case 1:
      if (isFlip) {
        return {
          title: 'All Analyses Complete!',
          description: 'View your property analysis below',
        };
      }
      return {
        title: `1${unfinishedTitle}`,
        description: unfinishedDescription,
      };
    case 2:
      return {
        title: `2${unfinishedTitle}`,
        description: unfinishedDescription,
      };
    case 3:
      return {
        title: 'All Analyses Complete!',
        description: 'View your property analysis below',
      };
    default:
      return 'Complete the Purchase Worksheet to get started';
  }
};
